import React, { useRef, useEffect } from "react";
import NavPublicUser from "../navbarPublicUser"
import Footer from "../Footer";
import PubUserBody from "../pubuserbody";
import PubUsrSearch from "../pubUsrSearch";

export default function PublicUserSearch(){

    // 1. Create a ref to the search component
    const searchRef = useRef(null);

    // 2. Use useEffect to scroll to the component on page load
    useEffect(() => {
        // Check if the ref has a value and the element is in the DOM
        if (searchRef.current) {
            searchRef.current.scrollIntoView({
                behavior: 'smooth', // Optional: for a smooth scrolling animation
                block: 'start',      // Optional: align the top of the element to the top of the viewport
            });
        }
    }, []); // Empty dependency array ensures this runs only once on mount

    return(
        <div>
            <NavPublicUser />
            <PubUserBody />
            {/* 3. Attach the ref to a wrapper div around the component */}
            <div ref={searchRef}>
                <PubUsrSearch />
            </div>
            <Footer />
        </div>
    );
}